import { render } from "./Links.vue?vue&type=template&id=82139718&scoped=true&ts=true"
import script from "./Links.vue?vue&type=script&lang=ts"
export * from "./Links.vue?vue&type=script&lang=ts"

import "./Links.vue?vue&type=style&index=0&id=82139718&scoped=true&lang=scss"

import exportComponent from "/Users/leonardomarsigli/code/LeoMarseo/personal-projects/dirtysocks-fe/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-82139718"]])

export default __exports__